import { PATHS } from '@/app/router/paths'
import { AuthLayout, AuthLegalFooter, RustWordmark } from './AuthLayout'
import { LoginForm } from './AuthForms'

export default function CaregiverLoginPage() {
  return (
    <AuthLayout backTo={PATHS.role} backLabel="Terug naar rolkeuze">
      <RustWordmark width={140} />
      <h1 className="auth-headline" style={{ fontSize: 26 }}>
        Inloggen als begeleider
      </h1>
      <p className="auth-subtitle">Log in om je gekoppelde cliënten te volgen.</p>
      <LoginForm role="caregiver" />
      <AuthLegalFooter />
    </AuthLayout>
  )
}
